import React from 'react';
import { motion } from 'framer-motion';
interface StickyNoteProps {
  text: string;
  rotation: number;
  colorClass: string;
  x: number;
  y: number;
}
export function StickyNote({
  text,
  rotation,
  colorClass,
  x,
  y
}: StickyNoteProps) {
  return <motion.div drag dragConstraints={{
    left: -50,
    right: 250,
    top: -50,
    bottom: 150
  }} whileHover={{
    scale: 1.05,
    zIndex: 10
  }} whileDrag={{
    scale: 1.1,
    zIndex: 20,
    rotate: 0
  }} initial={{
    rotate: rotation,
    x,
    y
  }} className={`absolute w-36 h-36 p-4 rounded-sm shadow-lg cursor-grab active:cursor-grabbing flex items-center justify-center text-center ${colorClass}`} style={{
    boxShadow: '4px 4px 15px rgba(0,0,0,0.5), inset 1px 1px 0 rgba(255,255,255,0.1)'
  }} data-id="element-65">
      <p className="font-syne font-semibold text-sm leading-tight text-white/90" data-id="element-66">
        {text}
      </p>

      {/* Tape effect */}
      <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-12 h-4 bg-white/10 backdrop-blur-sm transform -rotate-2" data-id="element-67" />
    </motion.div>;
}